import SectionHeading from "@/components/feature/SectionHeading";
import TopicCard from "@/components/feature/TopicCard";
import { allTopics, sortByUpdated } from "@/lib/site";

export default function FeaturedTopics() {
  const items = sortByUpdated(allTopics).slice(0, 6);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Dossiers"
          title="最近更新的事件档案"
          description="同一件事的后续往往比最初的热闹更值得看。以下档案在过去两周内都有新的节点补充。"
          actionLabel="全部话题档案"
          actionTo="/topics"
        />
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))}
        </div>
      </div>
    </section>
  );
}